import { Resource } from 'types';
import { ResourceActions } from 'types/store/actions/resources';
import { ResourceActionTypes } from 'types/store/actions/constants';
import Pagination from 'sources/sourceTypes/Pagination';

export const listSuccess = (
  payload: Pagination<Resource>
): ResourceActions => ({
  type: ResourceActionTypes.LIST_SUCCESS,
  payload,
});

export const listAllSuccess = (records: Array<Resource>): ResourceActions => ({
  type: ResourceActionTypes.LIST_ALL_SUCCESS,
  payload: { records },
});

export const reset = (): ResourceActions => ({
  type: ResourceActionTypes.RESET,
});
